import { useAuth } from '@/contexts/auth-context';
import { DiscountCodeManagementMode, discountCodeMode } from '@fluenceur/types';

/**
 * Whether the current brand manages its discount codes locally (internal or
 * partner account, no Shopify storefront). Derived from the brand account type
 * through `discountCodeMode` - the single source of truth shared with the
 * backend. Use this to hide Shopify-only surfaces (tracked links, checkout
 * enforced discount settings) rather than re-deriving from `accountType`.
 */
export function useIsLocalDiscountMode(): boolean {
  const { user } = useAuth();
  const accountType = user?.currentBrand?.accountType;

  return accountType ? discountCodeMode(accountType) === DiscountCodeManagementMode.LOCAL : false;
}
